// libraries
import { Badge } from '@interstate/components/Badge';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

// components
import { NonStyledButton, StyledOfferCardBadgesContainer } from '../offerCardContent/OfferCardContent.style';

type OfferCardBadgesProps = {
    isCurrent?: boolean;
    isAccepted?: boolean;
    isUpdated?: boolean;
    scenarioCount?: number;
    isPrimary?: boolean;
    toggleModal?: () => void;
};

export const OfferCardBadges = ({
    isCurrent,
    isAccepted,
    isUpdated,
    scenarioCount,
    isPrimary,
    toggleModal
}: OfferCardBadgesProps) => {
    const theme = useInterstateTheme();
    const displayedScenarioCount = scenarioCount && scenarioCount > 1 ? scenarioCount : null;

    const renderOfferCardAbPencilBadges = () => {
        return (
            <StyledOfferCardBadgesContainer theme={theme}>
                {(isPrimary || !!displayedScenarioCount) && (
                    <Badge variant="info" data-testid="offer-card-primary-offer">
                        Primary
                    </Badge>
                )}
                {isCurrent && (
                    <Badge variant="info" data-testid="offer-card-current-offer">
                        Current
                    </Badge>
                )}
                {!!displayedScenarioCount && (
                    <NonStyledButton onClick={toggleModal}>
                        <Badge variant="transparent" data-testid="offer-card-scenario-count-offer" className="badge-scenario-count">
                            <span data-testid="offer-card-scenario-count-button">{displayedScenarioCount}</span>
                        </Badge>
                    </NonStyledButton>
                )}
                {isAccepted && (
                    <Badge variant="success" data-testid="offer-card-accepted-offer">
                        Accepted
                    </Badge>
                )}
                {isUpdated && (
                    <Badge variant="success" data-testid="offer-card-updated-offer">
                        Updated
                    </Badge>
                )}
            </StyledOfferCardBadgesContainer>
        );
    };

    return renderOfferCardAbPencilBadges();
};
